import './index.css'

import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

import { yall } from 'yall-js'
import defineComponents from './js/utils/define-components'
import { bodyElement } from './js/components/common/body-element'

defineComponents()

window.bodyElement = bodyElement

window.auroraTheme = {
  ...window.auroraTheme,
  theme_version: '2.1.0',
  id: window.Shopify.theme.id,
  storeId: window.Shopify.theme.theme_store_id,
  isLicenseTheme: !!window.Shopify.theme.theme_store_id,
}

window.addEventListener('shopify:section:load', () => {
  yall({
    lazyClass: 'yall-video-lazy',
    threshold: 0,
  })
})

window.addEventListener('load', () => {
  yall({
    lazyClass: 'yall-video-lazy',
    threshold: 0,
  })
})
